import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BtnModule } from './btn/btn.shared.module';
import { ClearCartBtnModule } from './cartClearBtn';
import { CircleBtnModule } from './circleBtn';
import { IconBtnModule } from './iconBtn';

import { ButtonComponent } from './button.shared.component';

const toExport: any[] = [
    BtnModule,
    ClearCartBtnModule,
    CircleBtnModule,
    IconBtnModule,
];

@NgModule({
    declarations: [
        ButtonComponent,
    ],
    imports: [
        CommonModule,
        ...toExport
    ],
    exports: [
        ButtonComponent,
        ...toExport
    ],
    providers: [],
})
export class ButtonsModule { }
